"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
class AuthApi {
    constructor(api) {
        this.api = api;
        this.api.axiosGo.interceptors.response.use(data => data, (error) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            error = this.sanitizeError(error);
            console.log('[Axios][Interceptor] Response Error', error);
            this.api.logError(error);
            const res = error.response;
            const errorMessage = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.error) !== null && _b !== void 0 ? _b : '';
            // customer api token expired error
            if ((res === null || res === void 0 ? void 0 : res.status) === 401 && errorMessage.includes('error.token.expired')) {
                // customer token expired
                if (this.api.refreshCustomerApiCallback != null) {
                    try {
                        yield this.api.refreshCustomerApiCallback();
                        // retry with new token
                        if (error.config != null) {
                            error.config.headers.Authorization = this.api.axiosGo.defaults.headers.common.Authorization;
                            return yield this.api.axiosGo.request(error.config);
                        }
                    }
                    catch (error) {
                        return yield Promise.reject(error);
                    }
                }
                return yield Promise.reject(error);
            }
            // orderapp token expired error
            if (((res === null || res === void 0 ? void 0 : res.status) === 406 && errorMessage === 'token expired') || ((res === null || res === void 0 ? void 0 : res.status) === 401 && errorMessage === 'status not ok')) {
                if (this.api.refresh != null) {
                    try {
                        // refresh token
                        const user = yield this.refresh(this.api.refresh);
                        if (this.api.updateUserCallback != null) {
                            // 將新的 token 給 app 設定
                            yield this.api.updateUserCallback(user, error);
                        }
                        // retry with new token
                        if ((error === null || error === void 0 ? void 0 : error.config) != null) {
                            error.config.headers.Authorization = this.api.axiosGo.defaults.headers.common.Authorization;
                            return yield this.api.axiosGo.request(error.config);
                        }
                    }
                    catch (error) {
                        // refresh 失敗 要求重登
                        if (this.api.resetUserCallback != null) {
                            (_d = (_c = this.api).resetUserCallback) === null || _d === void 0 ? void 0 : _d.call(_c, errorMessage, error);
                            return yield Promise.reject(error);
                        }
                    }
                }
                // 沒有 refresh token 要求重登
                if (this.api.resetUserCallback != null) {
                    (_f = (_e = this.api).resetUserCallback) === null || _f === void 0 ? void 0 : _f.call(_e, errorMessage, error);
                    return yield Promise.reject(error);
                }
            }
            // other 401 error
            if ((res === null || res === void 0 ? void 0 : res.status) === 401) {
                if (this.api.resetUserCallback != null) {
                    this.api.resetUserCallback(errorMessage !== null && errorMessage !== void 0 ? errorMessage : res === null || res === void 0 ? void 0 : res.status, error);
                    return yield Promise.reject(error);
                }
            }
            return yield Promise.reject(error);
        }));
        this.api.axiosNode.interceptors.response.use(data => data, (error) => __awaiter(this, void 0, void 0, function* () {
            var _g, _h, _j, _k, _l;
            error = this.sanitizeError(error);
            console.log('[Axios][Interceptor] Response Error', error);
            this.api.logError(error);
            const res = error.response;
            const errorMessage = (_h = (_g = res === null || res === void 0 ? void 0 : res.data) === null || _g === void 0 ? void 0 : _g.message) !== null && _h !== void 0 ? _h : '';
            if ((res === null || res === void 0 ? void 0 : res.status) === 500 && errorMessage === 'UnauthorizedError: jwt expired') {
                if (this.api.refresh != null) {
                    const user = yield this.refresh(this.api.refresh);
                    if (this.api.updateUserCallback != null) {
                        this.api.updateUserCallback(user, error);
                    }
                    if ((error === null || error === void 0 ? void 0 : error.config) != null) {
                        error.config.headers.Authorization = this.api.axiosNode.defaults.headers.common.Authorization;
                        // retry
                        return yield this.api.axiosNode.request(error.config);
                    }
                }
            }
            else if ((res === null || res === void 0 ? void 0 : res.status) === 401) {
                if (this.api.resetUserCallback != null) {
                    this.api.resetUserCallback((_l = (_k = (_j = res === null || res === void 0 ? void 0 : res.data) === null || _j === void 0 ? void 0 : _j.error) !== null && _k !== void 0 ? _k : errorMessage) !== null && _l !== void 0 ? _l : res === null || res === void 0 ? void 0 : res.status, error);
                    return yield Promise.reject(error);
                }
            }
            return yield Promise.reject(error);
        }));
    }
    sanitizeError(error) {
        try {
            if (error.config != null) {
                const data = JSON.parse(error.config.data);
                if (lodash_1.default.get(data, 'payment.payload.paymentMethod.paymentCard') != null) {
                    delete data.payment.payload.paymentMethod.paymentCard;
                }
                error.config.data = JSON.stringify(data);
            }
        }
        catch (e) { }
        return error;
    }
    scopeLogin(merchantUsername, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/user/scopelogin';
            const data = {
                merchantUsername,
                username,
                password,
            };
            const response = yield this.api.axiosGo.post(endpoint, data);
            this.api.setToken(response.data.token, response.data.refresh);
            return response.data;
        });
    }
    register(payload = '', hash = '', client = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/user/register';
            const data = { payload, hash, client };
            const response = yield this.api.axiosGo.post(endpoint, data);
            this.api.setToken(response.data.token, response.data.refresh);
            return response.data;
        });
    }
    refresh(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/user/refresh';
            const response = yield this.api.axiosGo.post(endpoint, {
                token: token,
            });
            this.api.setToken(response.data.token, response.data.refresh);
            return response.data;
        });
    }
    createCustomer() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/customer';
            const response = yield this.api.axiosGo.post(endpoint);
            return response.data;
        });
    }
}
exports.default = AuthApi;
//# sourceMappingURL=Auth.js.map